<template>
  <div class="customers">
    <div class="page__header">
      <div class="page__title">{{ $t(`pageTitles.${"customers"}`) }}</div>
      <div class="page__right">
        <div class="selected-filters" v-if="selectedTeams.length > 0 || Object.keys(searchCustomerForms).length > 0">
          <div class="selected-filters__filter" v-for="teamId in selectedTeams" :key="`team${teamId}`">
            <span>
              Team: {{
                (loggedUser.teams && loggedUser.teams.find(t => t.id == teamId))
                  ? loggedUser.teams.find(t => t.id == teamId).name
                  : 'Team ' + teamId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyStartDate"}`) }}: {{ formatDate(startDateFrom) || '...' }} - {{
              formatDate(startDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyEndDate"}`) }}: {{ formatDate(endDateFrom) || '...' }} - {{
              formatDate(endDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="submitDateFrom || submitDateTo">
            <span>{{ $t(`searchCustomerFields.${"policySubmitDate"}`) }}: {{ formatDate(submitDateFrom) || '...' }} - {{
              formatDate(submitDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearSubmitDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="birthday">
            <span>{{ $t('searchCustomerFields.birthday') }}: {{ birthday }}</span>
            <div class="selected-filters__remove" @click="clearBirthday()"></div>
          </div>

          <div class="selected-filters__filter" v-if="zipFrom || zipTo">
            <span>{{ $t('searchCustomerFields.zip') }}: {{ formatRange(zipFrom, zipTo) }}</span>
            <div class="selected-filters__remove" @click="clearZip()"></div>
          </div>

          <div class="selected-filters__filter" v-if="pendencyNr">
            <span>{{ $t(`pendenciesTable.${"pendencyNr"}`) }}: {{ pendencyNr }}</span>
            <div class="selected-filters__remove" @click="clearPendencyNr()"></div>
          </div>

          <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
            <span>
              {{
                (searchCustomerForms.agents && searchCustomerForms.agents.find(a => a.id == agentId))
                  ? searchCustomerForms.agents.find(a => a.id == agentId).first_name + ' ' +
                  searchCustomerForms.agents.find(a => a.id == agentId).last_name
                  : 'Agent ' + agentId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="hasTerminations">
            <span>
              Kündigungen:
              <span v-if="hasTerminations == 'true'">ja</span>
              <span v-else-if="hasTerminations == 'false'">nien</span>
            </span>

            <div class="selected-filters__remove" @click="clearTermination()"></div>
          </div>

          <div class="selected-filters__filter" v-if="paymentStatus">
            <span>
              Payment: {{ paymentStatus }}
            </span>

            <div class="selected-filters__remove" @click="clearPayment()"></div>
          </div>

          <!-- <div class="selected-filters__filter" v-for="typeId in selectedCompanyTypes" :key="`type${typeId}`">
            <span>{{
              searchCustomerForms.companyTypes.find(
                (item) => item.id === typeId
              ).type
            }}</span>
            <div class="selected-filters__remove" @click="removeCompanyType(typeId)"></div>
          </div> -->

          <div class="selected-filters__filter" v-for="typeId in selectedCompanyTypes" :key="`type${typeId}`">
            <span>
              {{
                (searchCustomerForms.companyTypes && searchCustomerForms.companyTypes.find(item => item.id == typeId))
                  ? searchCustomerForms.companyTypes.find(item => item.id == typeId).type
              : '...'
              }}
            </span>
            <div class="selected-filters__remove" @click="removeCompanyType(typeId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="companyId in selectedCompanies" :key="`company${companyId}`">
            <!-- {{
              searchCustomerForms.companies.find(
                (item) => item.id === companyId
              ).name
            }} -->
            {{
              (searchCustomerForms.companies && searchCustomerForms.companies.find(item => item.id === companyId))
                ? searchCustomerForms.companies.find(item => item.id === companyId).name
                : '...'
            }}
            <div class="selected-filters__remove" @click="removeCompany(companyId)"></div>
          </div>
          <div class="selected-filters__filter" v-for="categoryId in selectedBranchCategories"
            :key="`category${categoryId}`">
            <!-- <span>{{
              searchCustomerForms.branchCategories.find(
                (item) => item.id === categoryId
              )[`long_${language}`]
            }}</span> -->
            <span>{{
              (searchCustomerForms.branchCategories && searchCustomerForms.branchCategories.find(item => item.id == categoryId))
                ? searchCustomerForms.branchCategories.find(item => item.id == categoryId)[`long_${language}`]
                : '...'
            }}</span>
            <div class="selected-filters__remove" @click="removeBranchCategory(categoryId)"></div>
          </div>
          <div class="selected-filters__filter" v-for="statusId in selectedPolicyStatuses" :key="`status${statusId}`">
            <!-- <span>{{
              searchCustomerForms.policyStatuses.find(
                (item) => item.id === statusId
              )[`long_${language}`]
            }}</span> -->
            <span>{{
  (searchCustomerForms.policyStatuses && searchCustomerForms.policyStatuses.find(item => item.id == statusId))
    ? searchCustomerForms.policyStatuses.find(item => item.id == statusId)[`long_${language}`]
    : '...'
}}</span>
            <div class="selected-filters__remove" @click="removePolicyStatus(statusId)"></div>
          </div>
        </div>
        <form class="search search--filter" @submit.prevent="searchCustomers()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="selected-filters__filter search__placeholder" v-if="searchPlaceholder">
              <div class="search__placeholder-content">
                {{ searchPlaceholder }}
                <div class="selected-filters__remove" @click="removeSearch()"></div>
              </div>
            </div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter v-if="showSearchFilter" :filterToggler="$refs.filterToggler" :searchType="'customer'"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>

        <button type="button" class="button button--default" @click="showAddCustomerModal()"
          v-if="$checkRolePermission('customer_create')">
          {{ $t(`dashboard.statistics.${"addCustomerBtn"}`) }}
        </button>
      </div>
    </div>

    <div class="customers__content">
      <Loading v-if="customersLoading" />
      <CustomersTable v-else :customers="customersPerPage.data || []" />
    </div>
    <Pagination :limit="3" :data="customersPerPage" @pagination-change-page="getResults"></Pagination>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import CustomersTable from "@/components/CustomersTable";
import Loading from "@/partials/Loading";
import SearchFilter from "@/partials/SearchFilter";

export default {
  name: "Customers",

  components: {
    CustomersTable,
    Loading,
    SearchFilter,
  },

  data() {
    return {
      searchPlaceholder: "",
      searchKeywords: "",
      showSearchFilter: false,
      selectedTeams: [],
      selectedAgents: [],
      selectedCompanyTypes: [],
      selectedCompanies: [],
      selectedBranchCategories: [],
      selectedPolicyStatuses: [],
      hasTerminations: "",
      paymentStatus: "",
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
      submitDateFrom: "",
      submitDateTo: "",
      birthday: "",
      zipFrom: "",
      zipTo: "",
      pendencyNr: "",
      initialLoadDone: false,
    };
  },

  watch: {
    "$route.query": {
      handler(query) {
        if (!query.page) {
          this.$router.replace({ query: { ...query, page: 1 } });
          return;
        }
        this.loadFiltersFromQuery(query);

        this.searchCustomers();
      },
      deep: true,
      immediate: true
    },
  },

  computed: {
    ...mapGetters([
      "customersPerPage",
      "customersLoading",
      "searchCustomerForms",
      "language",
      "loggedUser",
    ]),
  },
  async created() {
    const hasAccess = this.$checkRolePermission("customer_access") || this.$checkRolePermission("customer_show");
    if (!hasAccess) {
      this.$router.push("/dashboard");
      return;
    }

    try {
      const queryTeams = this.$route.query.teams ? this.$route.query.teams.split(",").map(Number) : [];

      if (queryTeams.length > 0) {
        await this.$store.dispatch("getSearchCustomerForms", queryTeams);
      } else if (this.loggedUser.teams && this.loggedUser.teams.length === 1) {
        await this.$store.dispatch("getSearchCustomerForms", [this.loggedUser.teams[0].id]);
      }
    } catch (error) {
      console.error("Error loading customer forms:", error);
    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);

      return `${day}/${month}/${year}`;
    },

    formatRange(from, to) {
      if (!from && !to) return '';
      if (from && !to) return `${from} - ...`;
      if (!from && to) return `... - ${to}`;
      return `${from} - ${to}`;
    },

    loadFiltersFromQuery(q) {
      this.searchKeywords = q.search || "";
      this.zipFrom = q.zip_from || "";
      this.zipTo = q.zip_to || "";
      this.pendencyNr = q.pendency_number || "";

      if (q.agents) {
        this.selectedAgents = typeof q.agents === 'string' ? q.agents.split(",") : q.agents;
      } else {
        this.selectedAgents = [];
      }


      this.selectedCompanyTypes = q.companyTypes
        ? (typeof q.companyTypes === 'string' ? q.companyTypes.split(",") : q.companyTypes)
        : [];

      this.selectedCompanies = q.companies
        ? (typeof q.companies === 'string' ? q.companies.split(",") : q.companies)
        : [];

      this.selectedBranchCategories = q.branchCategories
        ? (typeof q.branchCategories === 'string' ? q.branchCategories.split(",") : q.branchCategories)
        : [];

      this.selectedPolicyStatuses = q.policyStatuses
        ? (typeof q.policyStatuses === 'string' ? q.policyStatuses.split(",") : q.policyStatuses)
        : [];

      this.searchBirthday = q.birthday || "";
      this.hasTerminations = q.has_terminations || undefined;
      this.startDateFrom = q.startDateFrom || "";
      this.startDateTo = q.startDateTo || "";
      this.endDateFrom = q.endDateFrom || "";
      this.endDateTo = q.endDateTo || "";
      this.submitDateFrom = q.submitDateFrom || "";
      this.submitDateTo = q.submitDateTo || "";
      this.paymentStatus = q.payment_status || "";
    },

    async searchCustomers() {
      this.$store.commit("setCustomersLoading", true);

      const page = Number(this.$route.query.page) || 1;

      const teamsFromUrl = this.$route.query.teams;
      const teams = teamsFromUrl ? teamsFromUrl.split(",").map(Number) : [];

      await this.$store.dispatch("searchCustomers", {
        search: this.searchKeywords,
        agents: this.selectedAgents,
        companyTypes: this.selectedCompanyTypes,
        companies: this.selectedCompanies,
        branchCategories: this.selectedBranchCategories,
        policyStatuses: this.selectedPolicyStatuses,

        has_terminations: this.hasTerminations,
        payment_status: this.paymentStatus,

        startDateFrom: this.startDateFrom,
        startDateTo: this.startDateTo,
        endDateFrom: this.endDateFrom,
        endDateTo: this.endDateTo,
        submitDateFrom: this.submitDateFrom,
        submitDateTo: this.submitDateTo,
        zip_from: this.zipFrom,
        zip_to: this.zipTo,
        birthday: this.birthday,
        pendency_number: this.pendencyNr || undefined,
        teams,
        page,
      });

      this.$store.commit("setCustomersLoading", false);
    },

    updateQuery() {
      this.$router.replace({
        query: {
          page: 1,
          search: this.searchKeywords || undefined,
          teams: this.selectedTeams.length ? this.selectedTeams.join(",") : undefined,
          agents: this.selectedAgents.length ? this.selectedAgents.join(",") : undefined,
          companyTypes: this.selectedCompanyTypes.length ? this.selectedCompanyTypes.join(",") : undefined,
          companies: this.selectedCompanies.length ? this.selectedCompanies.join(",") : undefined,
          branchCategories: this.selectedBranchCategories.length ? this.selectedBranchCategories.join(",") : undefined,
          policyStatuses: this.selectedPolicyStatuses.length ? this.selectedPolicyStatuses.join(",") : undefined,
          has_terminations: this.hasTerminations || undefined,
          payment_status: this.paymentStatus || undefined,
          startDateFrom: this.startDateFrom || undefined,
          startDateTo: this.startDateTo || undefined,
          endDateFrom: this.endDateFrom || undefined,
          endDateTo: this.endDateTo || undefined,
          submitDateFrom: this.submitDateFrom || undefined,
          submitDateTo: this.submitDateTo || undefined,
          birthday: this.birthday || undefined,
          zip_from: this.zipFrom || undefined,
          zip_to: this.zipTo || undefined,
          pendency_number: this.pendencyNr || undefined,
        },
      }).catch(() => { });
    },

    getResults(paginationPage) {
      if (Number(this.$route.query.page) === Number(paginationPage)) return;

      this.$router.replace({
        query: { ...this.$route.query, page: paginationPage },
      }).catch(() => { });
    },

    clearStartDateRange() {
      this.startDateFrom = "";
      this.startDateTo = "";
      this.updateQuery();
    },

    clearEndDateRange() {
      this.endDateFrom = "";
      this.endDateTo = "";
      this.updateQuery();
    },

    clearSubmitDateRange() {
      this.submitDateFrom = "";
      this.submitDateTo = "";
      this.updateQuery();
    },

    clearBirthday() {
      this.birthday = "";
      this.updateQuery();
    },

    clearZip() {
      this.zipFrom = "";
      this.zipTo = "";
      this.updateQuery();
    },

    clearPendencyNr() {
      this.pendencyNr = "";
      this.updateQuery();
    },

    removeTeam(id) {
      this.selectedTeams = this.selectedTeams.filter((x) => x !== id);

      if (this.selectedTeams.length === 0) {
        this.clearAllDependentFilters();
      }

      this.updateQuery();
    },

    clearAllDependentFilters() {
      this.selectedAgents = [];
      this.selectedCompanyTypes = [];
      this.selectedCompanies = [];
      this.selectedBranchCategories = [];
      this.selectedPolicyStatuses = [];

      this.hasTerminations = "";
      this.paymentStatus = "";
      this.birthday = "";
      this.zipFrom = "";
      this.zipTo = "";
      this.pendencyNr = "";
      this.startDateFrom = "";
      this.startDateTo = "";
      this.endDateFrom = "";
      this.endDateTo = "";
      this.submitDateFrom = "";
      this.submitDateTo = "";

      this.$store.commit("setSearchCustomerForms", {});
    },

    removeAgent(id) {
      this.selectedAgents = this.selectedAgents.filter((x) => x !== id);
      this.updateQuery();
    },

    removeCompanyType(id) {
      this.selectedCompanyTypes = this.selectedCompanyTypes.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    removeCompany(id) {
      this.selectedCompanies = this.selectedCompanies.filter((x) => x !== id);
      this.updateQuery();
    },

    removeBranchCategory(id) {
      this.selectedBranchCategories = this.selectedBranchCategories.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    removePolicyStatus(id) {
      this.selectedPolicyStatuses = this.selectedPolicyStatuses.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    clearTermination() {
      this.hasTerminations = "";
      this.updateQuery();
    },

    clearPayment() {
      this.paymentStatus = "";
      this.updateQuery();
    },

    showAddCustomerModal() {
      this.$store.commit("setShowAddCustomerModal", true);
      this.$store.commit("setIsAddingCustomer", true);
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  &__right {
    flex: 3 !important;
  }
}

.customers {
  height: 100%;

  &__content {
    margin-bottom: 20px;
    height: calc(100% - 48px - 15px - 16px - 20px);
  }
}
</style>